module.exports = __webpack_public_path__ + "static/img/nophoto.b4ea200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nophoto.jpg
// module id = AV13
// module chunks = 0